module.exports = __webpack_public_path__ + "fe5f2b26e37bb652798006ca7ff8bc6c.png";